module.exports = __webpack_public_path__ + "img/8_14.2a02150c.png";